import "./App.css";
import React from "react";
import Game from "./Game";
import AddWord from "./AddWord";

function App() {
    return (
        <div>
            <Game />
            {/* <AddWord /> */}
        </div>
    );
}

export default App;
